export class ToastError extends Error {
    constructor(message) {
        super(message);
        this.type = 'ToastError';
    }
}
export function isToastError(error) {
    return error && error.type === 'ToastError';
}
